import { createContext } from "react"
import { CHAIN_ID } from "@mezo/sdk"
import { Chain } from "viem"
import { useAccount } from "wagmi"

import { ETHEREUM_NETWORK, MEZO_CHAIN } from "#/shared/constants"
import {
  EthersV5Signer,
  EthersV6Signer,
  useEthersV5Signer,
  useEthersV6Signer,
} from "#/shared/hooks/wagmi"

type CreateWalletContext = {
  address: `0x${string}` | undefined
  chain: Chain | undefined
  signerEthersV5: EthersV5Signer | undefined
  signerEthersV6: EthersV6Signer | undefined
  signerMezo: EthersV6Signer | undefined
}

export const WalletContext = createContext<CreateWalletContext>({
  address: undefined,
  chain: undefined,
  signerEthersV5: undefined,
  signerEthersV6: undefined,
  signerMezo: undefined,
})

export const useCreateWalletContext = (): CreateWalletContext => {
  const { address, chain } = useAccount()

  const signerEthersV5 = useEthersV5Signer({
    chainId: CHAIN_ID[ETHEREUM_NETWORK],
  })

  const signerEthersV6 = useEthersV6Signer({
    chainId: CHAIN_ID[ETHEREUM_NETWORK],
  })

  const signerMezo = useEthersV6Signer({ chainId: MEZO_CHAIN.id })

  return {
    address,
    chain,
    signerEthersV5,
    signerEthersV6,
    signerMezo,
  }
}
